import type { Step } from 'react-joyride'

export interface TourStep extends Step {
  /** Route the WebTour component should navigate to before showing this step */
  route?: string
  requiredPermission?: string
  disableBeacon?: boolean
  spotlightClicks?: boolean
  disableOverlayClose?: boolean
}

export const WEB_TOUR_STEPS: TourStep[] = [
  // ── Step 1 ── Welcome to NSC Portal ──────────────────
  {
    target: 'body',
    placement: 'center',
    title: 'Welcome to NSC Portal',
    content:
      'Your new Network Intelligence Console is ready.This quick tour will show you key insights, performance analytics, and how to navigate your dashboard effectively.',
    skipBeacon: true,
    route: '/home',
  },

  // ── Step 2 ── Customer Selection ──────────────────
  {
    target: '#tour-customer-selection',
    placement: 'bottom',
    title: 'Customer Selection',
    content:
      'Choose the Customer or Billing group you want to explore. This helps tailoring the dashboard of the exact account you are managing.',
    skipBeacon: true,
    route: '/home',
  },

  // ── Step 3 ── Site Selector ──────────────────
  {
    target: '#tour-site-selector',
    placement: 'bottom',
    title: 'Site Selector',
    content:
      'Choose the Customer site, that you want to explore. This helps in tailoring the dashboard of the exact account you are managing.',
    skipBeacon: true,
    route: '/home',
  },

  {
    target: '#tour-global-search',
    placement: 'bottom',
    title: 'Global Search',
    content:
      'Quickly find Cases, Sites, Devices, or Orders from anywhere in the portal. Use this universal search bar to jump directly to what you need.',
    skipBeacon: true,
    route: '/home',
  },

  {
    target: '#tour-home-overview',
    placement: 'bottom',
    title: 'Home Overview',
    content:
      'Return to the Home screen or navigate to different Overviews from here.',
    skipBeacon: true,
    route: '/home',
  },

  {
    target: '#tour-filters',
    placement: 'bottom',
    title: 'Filters',
    content:
      'Save Customized table views for faster access to your preferred data and layouts.',
    skipBeacon: true,
    route: '/home',
  },

  {
    target: '#checkbox_dropdown',
    placement: 'bottom',
    title: 'Customize Table',
    content:
      'Select the widgets you want to display on your dashboard. Show or hide sections to create a personalized view that focuses on the information most relevant to you.',
    skipBeacon: true,
    route: '/home',
  },

  {
    // target: '#tour-device-list',
    target: '[data-tour="Site List"]',
    placement: 'right',
    title: 'View Site List',
    content:
      "Select this option from the navigation panel to find you're customer's Site List.",
    skipBeacon: true,
    route: '/technologyandnetworks/sitelist',
  },

  {
    target: '#tour-device-list-filter',
    placement: 'bottom',
    title: 'Filter By',
    content:
      'Apply advanced filters to refine your data view. Quickly narrow the list by Location, Service type, Status, or other attributes.',
    skipBeacon: true,
    route: '/technologyandnetworks/sitelist',
  },

  {
    target: '#tour-device-list-customize-table',
    placement: 'bottom',
    title: 'Customize Table',
    content:
      'Show or hide columns to personalize your Table view. Adjust the layout to focus on the details that matter most to your workflow.',
    skipBeacon: true,
    route: '/technologyandnetworks/sitelist',
  },

  // {
  //   target: 'body',
  //   placement: 'center',
  //   title: 'Guideline Solution',
  //   content:
  //     'Choose the guidelines that apply to your current business needs to see relevant documentation.',
  //   skipBeacon: true,
  //   route: '/technologyandnetworks/sitelist',
  // },

  {
    target: '#tour-device-selection',
    placement: 'bottom',
    title: 'Device Selection',
    content: 'View and Track the list of all the Devices.',
    skipBeacon: true,
    route: '/technologyandnetworks/sitepage',
  },

  {
    target: '#tour-device-status',
    placement: 'bottom',
    title: 'Device Status',
    content:
      'View your Network status, Real-time connectivity graphs, Nodes or Alerts and Historical usage trends.',
    skipBeacon: true,
    route: '/technologyandnetworks/sitepage',
  },

  {
    target: '[data-tour="Active Services"]',
    placement: 'right',
    title: 'Active Services',
    content:
      'Choose your device from the list to view its detailed health and interface metrics.',
    skipBeacon: true,
    route: '/technologyandnetworks/activeservices',
  },

  {
    target: '[data-testid="table-container"]',
    placement: 'top',
    title: 'Select a Node',
    content: 'Click a node which has a valid network protocol (ICMP or SNMP)',
    skipBeacon: true,
    // spotlightClicks: true,
    // disableOverlayClose: true,
    route: '/technologyandnetworks/activeservices',
  },

  {
    target: '#tour-node-detail-card',
    placement: 'bottom',
    title: 'Node Details',
    content:
      'Here you can view Detailed Health, Interface Metrics, Latency, and Packet Loss for this specific node.',
    skipBeacon: true,
    requiredPermission: '/technologyandnetworks/activeservices',
  },

  {
    // target: '#tour-case-management',
    target: '[data-tour="Case Management"]',
    placement: 'right',
    title: 'Case Management',
    content:
      'View and track all support Cases for your Selected Customer or Site. Access detailed Ticket history, Status updates, and Resolution progress in one place.',
    skipBeacon: true,
    route: '/support/casemanagement',
  },

  {
    target: '#tour-knowledge-base-search',
    placement: 'bottom',
    title: 'Settings',
    content: 'You could Manage your Saved Sites and Saved Views here.',
    skipBeacon: true,
    route: '/settings',
  },
]
